import React from "react";
import styled from "styled-components";

const breakpoints = {
  tablet: 768,
  phone: 480,
};

const TAB_HOVER_COLOR = "#F7941D";

const TabsContainer = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  border-bottom: 2px solid #ccc;
  padding: 0 0 6px 0;
  margin: 0 0 16px 0;

  li {
    margin-right: 15px;
    margin-bottom: 0;
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 10px 14px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${({ colors }) => colors.cardBackground};
    color: ${({ colors }) => colors.buttonBackground};
    font-weight: 600;
    transition: all 0.2s;

    &.selected {
      background-color: ${({ colors }) => colors.buttonBackground};
      color: #fff;
      border-color: ${({ colors }) => colors.buttonBackground};
    }

    &:not(.selected) {
      background-color: ${({ colors }) => colors.titleText};
      color: ${({ colors }) => colors.buttonBackground};
    }

    &:hover {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: #fff;
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    justify-content: flex-start;
    overflow-x: auto;
    padding: 0 10px 6px;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;

    li {
      flex: 0 0 auto;
      margin-right: 10px;
    }
  }

  @media (max-width: ${breakpoints.phone}px) {
    margin-bottom: 12px;

    a {
      padding: 8px 12px;
      font-size: 0.9rem;
    }
  }
`;

export default function DashboardTabs({
  colors,
  tabs = [],
  selectedTab,
  onTabClick,
}) {
  const safeTabs = tabs.length ? tabs : ["Dashboard"];

  return (
    <TabsContainer colors={colors}>
      {safeTabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={(e) => {
              e.preventDefault();
              if (onTabClick) onTabClick(tab);
            }}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
}
